import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DxAdvisoryPage from "../pages/dx-advisory/page";
import AiOfficePage from "../pages/ai-office/page";
import PricingPage from "../pages/pricing/page";
import AboutPage from "../pages/about/page";
import AiDigitalPage from "../pages/ai-digital/page";
import BusinessToolPage from "../pages/business-tool/page";
import CaseStudiesPage from "../pages/case-studies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/service/dx-consultant",
    element: <DxAdvisoryPage />,
  },
  {
    path: "/service/ai-office",
    element: <AiOfficePage />,
  },
  {
    path: "/service/ai-digital",
    element: <AiDigitalPage />,
  },
  {
    path: "/service/business-tool",
    element: <BusinessToolPage />,
  },
  {
    path: "/cases",
    element: <CaseStudiesPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;